// apiService.js
import axios from 'axios';
import { useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL_DEV ;

// Create an Axios instance for centralized configuration
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// console.log("base url" , process.env.REACT_APP_BACKEND_BASE_URL_DEV )

// Interceptor for setting up Authorization header if JWT token is available
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwtToken'); // Adjust this to your storage solution
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


const apiService = {
  /**
   * GET request
   * @param {string} endpoint - API endpoint
   * @param {object} params - Query parameters for the GET request
   * @param {object} headers - Additional headers
   */
  get: async (endpoint, params = {}, headers = {}) => {
    try {
      const response = await axiosInstance.get(endpoint, { params, headers });
      return response.data;
    } catch (error) {
      console.error('Error in GET request:', error);
      throw error;
    }
  },

  /**
   * POST request
   * @param {string} endpoint - API endpoint
   * @param {object} data - Data payload for the POST request
   * @param {object} headers - Additional headers
   */
  post: async (endpoint, data = {}, headers = {}) => {
    try {
      const response = await axiosInstance.post(endpoint, data, { headers });
      return response.data;
    } catch (error) {
      console.error('Error in POST request:', error);
      throw error;
    }
  },

  /**
   * PATCH request
   * @param {string} endpoint - API endpoint
   * @param {object} data - Data payload for the PATCH request
   * @param {object} headers - Additional headers
   */
  patch: async (endpoint, data = {}, headers = {}) => {
    try {
      const response = await axiosInstance.patch(endpoint, data, { headers });
      return response.data;
    } catch (error) {
      console.error('Error in PATCH request:', error);
      throw error;
    }
  },

  /**
   * DELETE request
   * @param {string} endpoint - API endpoint
   * @param {object} headers - Additional headers
   */
  delete: async (endpoint, headers = {}) => {
    try {
      const response = await axiosInstance.delete(endpoint, { headers });
      return response.data;
    } catch (error) {
      console.error('Error in DELETE request:', error);
      throw error;
    }
  },

  /**
   * Custom request with all configurations
   * @param {string} method - HTTP method (GET, POST, PATCH, DELETE)
   * @param {string} endpoint - API endpoint
   * @param {object} [data={}] - Data payload
   * @param {object} [params={}] - Query parameters
   * @param {object} [headers={}] - Headers
   */
  request: async ({ method, endpoint, data = {}, params = {}, headers = {} }) => {
    try {
      const response = await axiosInstance.request({
        url: endpoint,
        method,
        data,
        params,
        headers,
      });
      return response.data;
    } catch (error) {
      console.error(`Error in ${method.toUpperCase()} request:`, error);
      throw error;
    }
  },
};

export default apiService;
